var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Import Promotion"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Promotion"}},[_c('div',{staticClass:"tab-text"},[_c('promotion')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }